import { render, staticRenderFns } from "./tzList.vue?vue&type=template&id=55e121d4&scoped=true"
import script from "./tzList.vue?vue&type=script&lang=js"
export * from "./tzList.vue?vue&type=script&lang=js"
import style0 from "./tzList.vue?vue&type=style&index=0&id=55e121d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e121d4",
  null
  
)

export default component.exports